export const PopupEnum = {
    CREATE: {
        id: "create-modal",
        title: "Δημιουργία νέας εγγραφής",
        type: "create"
    },
    EDIT: {
        id: "edit-modal",
        title: "Επεξεργασία εγγραφής",
        type: "info"
    },
    CREATE_INTERNAL: {
        id: "create-internal-modal",
        title: "Δημιουργία νέας εγγραφής",
        type: "create"
    },
    EDIT_INTERNAL: {
        id: "edit-internal-modal",
        title: "Επεξεργασία εγγραφής",
        type: "info"
    },
    DELETE: {
        id: "delete-modal",
        title: "Διαγραφή εγγραφής",
        type: "delete"
    },
    INFO: {
        id: "info-modal",
        title: "Πληροφορίες εγγραφής",
        type: "info"
    },
    UNSAVED_CHANGES: {
        id: "info-modal",
        title: 'Έξοδος',
        type: "info"
    },
    SEARCH: {
        id: "search-modal",
        title: 'Έξοδος',
        type: "success"
    },
    NO_MODAL: {
        id: "no-modal",
        title: 'Προσοχή μη αποθηκευμένες εγγραφές',
        type: "info"
    }
}
export const YesNoEnum = {
    yesNo:
        [
            {
                value: 1,
                text: "Ναι",
            },
            {
                value: 0,
                text: "Οχι",
            }
        ]
}
export const SyggenikiSxesiEnum = {
    syggenikiSxesi:
        [
            {
                text: "Δικαστικός / Εισαγγελικός λειτουργός",
                value: {
                    value: 1,
                    text: "Δικαστικός / Εισαγγελικός λειτουργός",
                },
            },
            {
                text: "Σύζυγος / ΜΣΣ",
                value: {
                    value: 2,
                    text: "Σύζυγος / ΜΣΣ",
                },
            },
            {
                text: "Ανήλικο Τέκνο",
                value: {
                    value: 3,
                    text: "Ανήλικο Τέκνο",
                },

            }
        ]
}

export const PENDING_APPROVAL = 'Εκκρεμεί Έγκριση'
export const INVALID_DATE = 'Invalid date'

export const ResponseModel = {
    fields: [],
    form: {}
}

export const SORT_TYPE = {
    ASC: 'asc',
    DESC: 'desc'
}